/* FadCloset — theme.js : header nav, cart count, small shared behaviour */
(function () {
  'use strict';

  // Mobile navigation
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.getElementById('site-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Keep the header cart count honest after any AJAX add
  window.FadCloset = window.FadCloset || {};
  window.FadCloset.refreshCart = function () {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var el = document.querySelector('[data-cart-count]');
        if (el) el.textContent = cart.item_count;
        return cart;
      });
  };

  window.FadCloset.money = function (cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  };

  // Nav dropdowns (Men / Women submenus)
  function closeDropdowns(except) {
    document.querySelectorAll('[data-nav-dropdown].is-open').forEach(function (item) {
      if (item === except) return;
      item.classList.remove('is-open');
      item.querySelector('[data-nav-dropdown-toggle]').setAttribute('aria-expanded', 'false');
    });
  }
  document.querySelectorAll('[data-nav-dropdown-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var item = btn.closest('[data-nav-dropdown]');
      var open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      closeDropdowns(item);
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-nav-dropdown]')) closeDropdowns();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDropdowns();
  });

  // Men's / Women's toggle on featured-collection sections
  document.querySelectorAll('[data-gender-root]').forEach(function (root) {
    var inputs = root.querySelectorAll('[data-gender-toggle] input[type="radio"]');
    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        root.querySelectorAll('[data-gender-panel]').forEach(function (panel) {
          panel.hidden = panel.dataset.genderPanel !== input.value;
        });
      });
    });
  });
})();
